const CaptureConditionsModal = ({ show, step, maxImages, onStart, onClose }) => {
    if (!show) return null

    const isNoMask = step === 'no_mask'

    return (
        <>
            <div
                className="modal fade show modal-dark"
                style={{ display: 'block' }}
                tabIndex="-1"
                aria-modal="true"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title d-flex align-items-center gap-2">
                                <span>{isNoMask ? '🙂' : '😷'}</span>
                                {isNoMask ? 'Étape 1 — Capture sans masque' : 'Étape 2 — Capture avec masque'}
                            </h5>
                            <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
                        </div>

                        <div className="modal-body">
                            <p className="small mb-3" style={{ color: 'rgba(255,255,255,0.5)' }}>
                                Avant de commencer, assurez-vous de respecter les conditions suivantes
                                pour garantir la qualité des images collectées.
                            </p>

                            <div className="rounded-3 p-3" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
                                {isNoMask ? (
                                    <ul className="mb-0" style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.9rem', paddingLeft: '1.2rem', lineHeight: 2 }}>
                                        <li>Retirez tout masque, couvre-bouche ou protection faciale</li>
                                        <li>Placez-vous face à la caméra, à environ 50 cm</li>
                                        <li>Éclairage homogène recommandé — évitez les contre-jours</li>
                                        <li>Gardez une expression neutre et variez légèrement l'orientation de la tête</li>
                                        <li><strong style={{ color: '#6ea8fe' }}>{maxImages} photos</strong> seront prises automatiquement</li>
                                    </ul>
                                ) : (
                                    <ul className="mb-0" style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.9rem', paddingLeft: '1.2rem', lineHeight: 2 }}>
                                        <li>Portez un masque chirurgical ou tout autre type de cache-nez</li>
                                        <li>Même distance et conditions d'éclairage que l'étape précédente</li>
                                        <li>Assurez-vous que le masque couvre entièrement nez et bouche</li>
                                        <li>Variez légèrement l'orientation de la tête comme à l'étape précédente</li>
                                        <li><strong style={{ color: '#6ea8fe' }}>{maxImages} photos</strong> seront prises automatiquement</li>
                                    </ul>
                                )}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={onStart}>
                                Commencer la capture
                            </button>
                            <button type="button" className="btn btn-outline-light" onClick={onClose}>
                                Annuler
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" style={{ background: 'rgba(5,15,30,0.8)' }} onClick={onClose} />
        </>
    )
}

export default CaptureConditionsModal